import styles from './IconDefault.module.scss';

export function IconInProgress() {
	return (
		<svg
			width="40"
			height="40"
			fill="none"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			className={styles.mediumIllustration}
		>
			<circle
				cx="21"
				cy="21.49"
				r="16"
				fill="var(--coral-color-illustration-color-03, hsla(138, 19%, 90%, 1))"
			/>
			<path
				fill="var(--coral-color-illustration-color-02, hsla(0, 0%, 35%, 1))"
				fillRule="evenodd"
				d="M19.5 4.49a1 1 0 0 1 1-1 17.5 17.5 0 0 1 0 35 1 1 0 1 1 0-2 15.5 15.5 0 1 0 0-31 1 1 0 0 1-1-1Z"
				clipRule="evenodd"
			/>
			<path
				fill="var(--coral-color-illustration-color-02, hsla(0, 0%, 35%, 1))"
				fillRule="evenodd"
				d="M20.684 37.478a1 1 0 0 1-.989 1.01c-.19.003-.382.002-.572-.002a1 1 0 1 1 .043-2c.168.004.338.005.507.003a1 1 0 0 1 1.011.989Zm-5.884-.64a1 1 0 0 1-1.281.598 17.49 17.49 0 0 1-1.063-.426 1 1 0 0 1 .805-1.831c.31.136.624.262.941.377a1 1 0 0 1 .598 1.282Zm-5.707-3.005a1 1 0 0 1-1.412.062 17.622 17.622 0 0 1-.82-.8 1 1 0 0 1 1.445-1.384 15.53 15.53 0 0 0 .725.71 1 1 0 0 1 .062 1.412Zm-4.122-4.96a1 1 0 0 1-1.33-.483 17.514 17.514 0 0 1-.45-1.053 1 1 0 0 1 1.864-.726c.123.315.256.626.399.933a1 1 0 0 1-.483 1.329Zm-1.911-6.16a1 1 0 0 1-1.043-.956 17.552 17.552 0 0 1-.013-1.145 1 1 0 1 1 2 .043 15.54 15.54 0 0 0 .011 1.015 1 1 0 0 1-.955 1.043Zm.592-6.423a1 1 0 0 1-.598-1.281c.13-.36.273-.714.426-1.063a1 1 0 1 1 1.831.805c-.136.31-.262.623-.377.941a1 1 0 0 1-1.282.598Zm3.005-5.707a1 1 0 0 1-.062-1.413 17.54 17.54 0 0 1 .8-.819A1 1 0 0 1 8.78 9.796a15.353 15.353 0 0 0-.71.725 1 1 0 0 1-1.412.062Zm4.96-4.123a1 1 0 0 1 .483-1.329c.347-.161.698-.311 1.053-.45a1 1 0 1 1 .726 1.864c-.315.123-.626.256-.933.399a1 1 0 0 1-1.329-.484Zm6.16-1.91a1 1 0 0 1 .956-1.043c.19-.009.38-.014.572-.016a1 1 0 0 1 .022 2c-.17.002-.338.006-.507.014a1 1 0 0 1-1.043-.955Z"
				clipRule="evenodd"
			/>
			<path
				fill="var(----coral-color-neutral-background, hsla(0, 0%, 100%, 1))"
				d="m11.354 22.865 5.657 5.657a.5.5 0 0 0 .707 0l1.15-1.15 1.502-1.502 1.503-1.503L26.5 19.74l2.532-2.532a.5.5 0 0 0 0-.707l-2.475-2.475a.5.5 0 0 0-.707 0l-8.132 8.132a.5.5 0 0 1-.707 0l-2.475-2.475a.5.5 0 0 0-.707 0l-2.475 2.474a.5.5 0 0 0 0 .708Z"
			/>
			<path
				stroke="var(--coral-color-illustration-color-02, hsla(0, 0%, 35%, 1))"
				strokeLinecap="round"
				strokeWidth="2"
				d="m26.499 19.74 2.532-2.532a.5.5 0 0 0 0-.707l-2.475-2.475a.5.5 0 0 0-.707 0l-8.131 8.132a.5.5 0 0 1-.708 0l-2.475-2.475a.5.5 0 0 0-.707 0l-2.475 2.474a.5.5 0 0 0 0 .708l5.657 5.657a.5.5 0 0 0 .707 0l1.15-1.15 1.502-1.502 1.503-1.503"
			/>
			<path
				fill="var(--coral-color-illustration-color-02, hsla(0, 0%, 35%, 1))"
				d="M25 21.99a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
			/>
		</svg>
	);
}
